import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import {
  cartTopRefUpdate,
  cartBottomRefUpdate,
  cartTypeUpdate,
} from "../../store/actions/cartPosition";
import { removeCart } from "../../store/actions/cart";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../../config";
import calculatePrice from "../../helpers/calculatePrice";
import activeDiscount from "../../helpers/activeDiscount";
import { fetchCurrentPrices } from "../../utils/cartSync";
import "./Cart.css";

class Cart extends Component {
  state = {
    isOpen: false,
    showPriceDetail: false,
    showScrollIndicator: false,
    validatedItems: null,
  };

  constructor(props) {
    super(props);
    this.cartRef = React.createRef();
    this.cartTop = React.createRef();
    this.cartBottom = React.createRef();
    this.cartItemsScrollRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
    this.props.cartTopRefUpdate(this.cartTop);
    this.props.cartBottomRefUpdate(this.cartBottom);

    // Fetch validated prices on mount
    if (this.props.cart.items && this.props.cart.items.length > 0) {
      this.fetchPrices();
    }
  }

  componentDidUpdate(prevProps) {
    const prevLength = prevProps.cart.items ? prevProps.cart.items.length : 0;
    const currentLength = this.props.cart.items ? this.props.cart.items.length : 0;

    if (prevLength !== currentLength) {
      this.checkScrollIndicator();

      // Refetch prices when cart changes
      if (currentLength > 0) {
        this.fetchPrices();
      }
    }
  }

  fetchPrices = async () => {
    const result = await fetchCurrentPrices(this.props.cart.items);
    this.setState({
      validatedItems: result.items,
    });
  };

  getValidatedItem = (item) => {
    if (this.state.validatedItems) {
      const validated = this.state.validatedItems.find(v => v.id === item.id);
      if (validated) {
        return validated;
      }
    }
    return item;
  };

  getCurrentPrice = (item) => {
    const validated = this.getValidatedItem(item);
    return validated.current_price || validated.sale_price || validated.price;
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    document.body.classList.remove('cart-open');
  }

  handleClickOutside = (event) => {
    if (
      this.cartRef.current &&
      !this.cartRef.current.contains(event.target) &&
      this.state.isOpen
    ) {
      this.setState({ isOpen: false, showPriceDetail: false });
      document.body.classList.remove('cart-open');
    }
  };

  toggleCart = () => {
    this.setState({ isOpen: !this.state.isOpen }, () => {
      if (this.state.isOpen) {
        this.checkScrollIndicator();
        document.body.classList.add('cart-open');
      } else {
        document.body.classList.remove('cart-open');
      }
    });
  };

  togglePriceDetail = () => {
    this.setState({ showPriceDetail: !this.state.showPriceDetail });
  };

  closeCart = () => {
    this.setState({ isOpen: false, showPriceDetail: false });
    document.body.classList.remove('cart-open');
  };

  checkScrollIndicator = () => {
    setTimeout(() => {
      if (this.cartItemsScrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = this.cartItemsScrollRef.current;
        const isScrollable = scrollHeight > clientHeight;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5; // 5px tolerance
        this.setState({ showScrollIndicator: isScrollable && !isAtBottom });
      }
    }, 100);
  };

  handleScroll = () => {
    this.checkScrollIndicator();
  };

  renderCartItems() {
    if (this.props.cart.items.length === 0) {
      return (
        <div className="empty-cart">
          <div className="empty-cart-icon">
            <FontAwesomeIcon icon={["fas", "shopping-basket"]} />
          </div>
          <h4>Sepetiniz Boş</h4>
          <p>Alışverişe başlamak için ürün ekleyin</p>
          <Link to="/" className="continue-shopping" onClick={this.closeCart}>
            <FontAwesomeIcon icon={["fas", "arrow-left"]} />
            Alışverişe Devam Et
          </Link>
        </div>
      );
    }

    return (
      <div className="cart-items-container">
        <div 
          className="cart-items-scroll" 
          ref={this.cartItemsScrollRef}
          onScroll={this.handleScroll}
        >
          {this.props.cart.items.map((item, i) => (
            <div key={i} className="cart-item">
              <div className="cart-item-image">
                <Link
                  to={{
                    pathname: `/urun/${item.slug}`,
                    state: { product: item },
                  }}
                  onClick={this.closeCart}
                >
                  <img src={PUBLIC_URL(item.image)} alt={item.name} />
                  {activeDiscount(item.categories) && (
                    <span className="discount-badge">
                      {activeDiscount(item.categories).type === "percent" 
                        ? `%${activeDiscount(item.categories).discount}` 
                        : `₺${activeDiscount(item.categories).discount}`}
                    </span>
                  )}
                </Link>
              </div>
              <div className="cart-item-details">
                <Link
                  to={{
                    pathname: `/urun/${item.slug}`,
                    state: { product: item },
                  }}
                  onClick={this.closeCart}
                  className="cart-item-name"
                  title={item.name}
                >
                  {item.name}
                </Link>
                <div className="cart-item-meta">
                  <span className="cart-item-quantity">
                    <FontAwesomeIcon icon={["fas", "times"]} />
                    {parseInt(item.quantity) || 1} adet
                  </span>
                  <div className="cart-item-price">
                    {activeDiscount(item.categories) ? (
                      <React.Fragment>
                        <span className="old-price">
                          ₺{(() => {
                            const quantity = parseInt(item.quantity) || 1;
                            const price = parseFloat(this.getCurrentPrice(item)) || 0;
                            return (price * quantity).toFixed(2);
                          })()}
                        </span>
                        <span className="discount-price">
                          ₺
                          {(() => {
                            const validatedItem = this.getValidatedItem(item);
                            return calculatePrice(
                              validatedItem,
                              activeDiscount(item.categories)
                            );
                          })()}
                        </span>
                      </React.Fragment>
                    ) : (
                      <span className="regular-price">
                        ₺{(() => {
                          const quantity = parseInt(item.quantity) || 1;
                          const price = parseFloat(this.getCurrentPrice(item)) || 0;
                          return (price * quantity).toFixed(2);
                        })()}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                className="cart-item-remove"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.removeCart(item);
                }}
                title="Ürünü Kaldır"
                aria-label={`${item.name} ürünunu sepetten kaldır`}
              >
                <FontAwesomeIcon icon={["fas", "times"]} />
              </button>
            </div>
          ))}
        </div>
        
        {this.state.showScrollIndicator && (
          <div className="cart-scroll-indicator">
            <FontAwesomeIcon icon={["fas", "chevron-down"]} />
            <span>Daha fazla ürün için kaydırın</span>
          </div>
        )}
      </div>
    );
  }

  calculateCustomerDiscount = (subtotal) => {
    const { customer } = this.props.customer;

    if (
      !customer ||
      !customer.discount_enabled ||
      subtotal < customer.min_cart_amount
    ) {
      return 0;
    }

    if (customer.discount_type === "percentage") {
      return subtotal * (customer.discount_value / 100);
    } else if (customer.discount_type === "fixed") {
      return customer.discount_value;
    }

    return 0;
  };

  render() {
    const cartItemCount = this.props.cart.items.length > 0
      ? this.props.cart.items.map((v) => parseInt(v.quantity) || 0).reduce((a, b) => a + b)
      : 0;

    // Toplam fiyat hesaplama (indirim uygulanmış)
    const cartTotalDiscountPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((product) => {
                const validatedProduct = this.getValidatedItem(product);
                // validatedProduct'a quantity'yi ekle (fetchCurrentPrices quantity'yi kaybediyor)
                const productWithQuantity = {
                  ...validatedProduct,
                  quantity: product.quantity
                };
                return parseFloat(
                  calculatePrice(productWithQuantity, activeDiscount(product.categories))
                );
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    // Ara toplam (indirim uygulanmamış)
    const cartTotalPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((item) => {
                const quantity = parseInt(item.quantity) || 0;
                const price = parseFloat(this.getCurrentPrice(item)) || 0;
                return quantity * price;
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    // Sepet indirimi: Sadece indirimli ürünlerin indirim tutarları toplamı
    const cartDiscount = this.props.cart.items.length > 0
      ? parseFloat(
          this.props.cart.items
            .map((item) => {
              const discount = activeDiscount(item.categories);
              if (!discount) return 0;

              const validatedItem = this.getValidatedItem(item);
              // item.quantity kullan (validatedItem.quantity değil)
              const quantity = parseInt(item.quantity) || 0;
              const basePrice = parseFloat(validatedItem.current_price || validatedItem.sale_price || validatedItem.price) || 0;

              if (discount.type === "percent") {
                return (basePrice * (discount.discount / 100)) * quantity;
              } else {
                return Math.min(discount.discount, basePrice) * quantity;
              }
            })
            .reduce((a, b) => a + b, 0)
            .toFixed(2)
        )
      : 0;

    const customerDiscount = this.calculateCustomerDiscount(cartTotalDiscountPrice);
    const finalCartPrice = cartTotalDiscountPrice - customerDiscount;

    // If cart is empty, set everything to 0
    const setting = this.props.setting && this.props.setting.setting;
    const shippingCost = (this.props.cart.items.length === 0 || finalCartPrice === 0 || !setting)
      ? 0
      : (finalCartPrice >= setting.free_shipping ? 0 : setting.shipping_cost);

    const finalTotal = (this.props.cart.items.length === 0) ? 0 : finalCartPrice + shippingCost;

    return (
      <div className="modern-cart-wrapper" ref={this.cartRef}>
        <div className="cart-trigger-container">
          <button
            ref={this.cartTop}
            className="cart-trigger"
            onClick={this.toggleCart}
            aria-label="Sepet"
          >
            <FontAwesomeIcon icon={["fas", "shopping-basket"]} />
            {cartItemCount > 0 && (
              <span className="cart-count">{cartItemCount}</span>
            )}
          </button>
          <div className="cart-summary">
            <Link to="/sepet" onClick={this.closeCart}>Sepetim</Link>
            <span className="cart-total">₺{finalTotal.toFixed(2)}</span>
          </div>
        </div>

        <div className={`cart-dropdown ${this.state.isOpen ? 'open' : ''}`}>
          <div className="cart-dropdown-header">
            <h3>
              <FontAwesomeIcon icon={["fas", "shopping-basket"]} />
              Sepetim ({cartItemCount} Ürün)
            </h3>
            <button onClick={this.toggleCart} className="cart-close">
              <FontAwesomeIcon icon={["fas", "times"]} />
            </button>
          </div>

          <div className="cart-dropdown-body">
            {this.renderCartItems()}
          </div>

          {this.props.cart.items.length > 0 && (
            <div className="cart-dropdown-footer">
              <div className="cart-price-summary">
                <button
                  className="price-detail-toggle"
                  onClick={this.togglePriceDetail}
                >
                  <FontAwesomeIcon
                    icon={["fas", this.state.showPriceDetail ? "chevron-up" : "chevron-down"]}
                  />
                  Fiyat Detayı
                </button>
                
                <div className={`price-detail ${this.state.showPriceDetail ? 'show' : ''}`}>
                  <div className="price-row">
                    <span>Ara Toplam:</span>
                    <span>₺{cartTotalPrice.toFixed(2)}</span>
                  </div>
                  {cartDiscount > 0 && (
                    <div className="price-row discount">
                      <span>Sepet İndirimi:</span>
                      <span>-₺{cartDiscount.toFixed(2)}</span>
                    </div>
                  )}
                  {customerDiscount > 0 && (
                    <div className="price-row discount">
                      <span>Premium Müşteri İndirimi:</span>
                      <span>-₺{customerDiscount.toFixed(2)}</span>
                    </div>
                  )}
                  <div className="price-row">
                    <span>Kargo:</span>
                    <span>
                      {shippingCost === 0 ? (
                        <span className="free-shipping">Ücretsiz</span>
                      ) : (
                        `₺${shippingCost.toFixed(2)}`
                      )}
                    </span>
                  </div>
                  {shippingCost === 0 && setting && (
                    <div className="free-shipping-info">
                      ₺{setting.free_shipping} ve üzeri ücretsiz kargo
                    </div>
                  )}
                  {setting && finalCartPrice < setting.free_shipping && finalCartPrice > 0 && (
                    <div className="free-shipping-info">
                      Ücretsiz kargo için ₺{(setting.free_shipping - finalCartPrice).toFixed(2)} daha ekleyin
                    </div>
                  )}
                </div>

                <div className="cart-total-row">
                  <span>Toplam:</span>
                  <span className="total-price">₺{finalTotal.toFixed(2)}</span>
                </div>
              </div>

              <div className="cart-actions">
                <Link
                  to="/sepet"
                  className="btn-view-cart"
                  onClick={this.closeCart}
                >
                  Sepeti Görüntüle
                </Link>
                <Link
                  to={this.props.customer.customer ? "/odeme" : "/odeme/giris"}
                  className="btn-checkout"
                  onClick={this.closeCart}
                >
                  Ödemeye Geç
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ cart, setting, customer }) => {
  return { cart, setting, customer };
};

const mapDispatchToProps = {
  removeCart,
  cartTopRefUpdate,
  cartBottomRefUpdate,
  cartTypeUpdate,
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);


// WEBPACK FOOTER //
// ./src/components/shared/Cart.js